
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-care/[slug]",
      function () {
        return require("private-next-pages/get-care/[slug].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-care/[slug]"])
      });
    }
  